module.exports = __webpack_public_path__ + "static/media/logo_border_star_00024.7a7f4aef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/border-star/logo_border_star_00024.png
// module id = 437
// module chunks = 0